// extracted by mini-css-extract-plugin
module.exports = {"photo-low-priority-single-author":"photo-low-priority-single-author-m__photo-low-priority-single-author__33e-Y"};